export default __webpack_public_path__ + "static/media/preserve.7a436f84.svg";